import { LogEntry } from '../types'

export interface UserLabel {
  label: string
  kind: 'user' | 'system'
}

export function getUserLabel(entry: LogEntry): UserLabel {
  if (entry.user != null && entry.user !== '') {
    return { label: entry.user, kind: 'user' }
  }
  const userId = entry.metadata.userId
  if (userId != null && userId !== '') {
    return { label: userId, kind: 'user' }
  }
  return { label: 'System', kind: 'system' }
}
